import { render, staticRenderFns } from "./CourseLessonVideo.vue?vue&type=template&id=5f4eaad6&"
import script from "./CourseLessonVideo.vue?vue&type=script&lang=js&"
export * from "./CourseLessonVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports